import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ToastData } from '../common/toasts/toasts.component';

@Injectable({
  providedIn: 'root'
})
export class ToastsService {
  private newSubj$: Subject<ToastData> = new Subject<ToastData>();

  public constructor() {
  }

  public get new$(): Observable<ToastData> {
    return this.newSubj$.asObservable();
  }

  public show(item: ToastData) {
    this.newSubj$.next(item);
  }
}
